import ActiveColor from './activeColor.vue';

const ActiveColorComponent = {
  install: (app) => {
    app.component('KActiveColor', ActiveColor);
  },
};

export default ActiveColorComponent;
